import React from 'react';
import DocsAccess from "../Components/DocsAdmin/DocsSearch/DocsAccess";

function DocsAccessPage(props) {
  return (
    <DocsAccess/>
  );
}

export default DocsAccessPage;